import { Navigate, Routes, Route, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { BulkUpload } from '../components/BulkUpload'

const BulkOperationsPage = () => {
  const userBreadCrumbs: Array<PageLink> = [
    {
      title: 'Operaciones Masivas',
      path: '/bulk-operations/upload',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='upload'
          element={
            <>
              <PageTitle breadcrumbs={userBreadCrumbs}>
                Carga masiva de recargas
              </PageTitle>
              <BulkUpload />
            </>
          }
        />
      </Route>

      {/* Si entran a /bulk-operations/ que redirija a upload */}
      <Route index element={<Navigate to='upload' replace />} />
    </Routes>
  )
}

export default BulkOperationsPage
